import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";
// import FilterModal from "../Modal/FilterModal";
import FilterDetailsModal from "../Modal/FilterDetailsModal";
import { GetWorkflowFilter } from "../utilities/WorkFlowUtilities";

const CustomNodeFilterData = ({ id, data, onChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [filterData, setFilterData] = useState();
  const [filter, setFilter] = useState(data);
  const [workflowFilter, setWorkflowFilter] = useState();
  const [editData, setEditData] = useState({});
  const [addNewFilter, setAddNewFilter] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const result = async () => {
      const filterResponse = await fetchFilters();
      setFilterData(filterResponse?.data?.items);
    };

    result();
  }, []);

  useEffect(() => {
    const result = async () => {
      let id = data?.id;
      const WorkflowResponse = await GetWorkflowFilter(id);
      setWorkflowFilter(WorkflowResponse?.filters);
    };

    result();
  }, []);

  const handleFilterChange = (event) => {
    const selectedFilter = event.target.value;
    let selectedData = { id: "" };
    if (selectedFilter !== "") {
      selectedData =
        filterData && filterData.find((p) => p.id === parseInt(selectedFilter));
    }
    setFilter(selectedFilter);

    if (onChange) {
      onChange(id, selectedData);
    }
  };
  const handleFilter = () => {
    setAddNewFilter((state) => !state);
  };
  return (
    <>
      <div className="custom-node">
        <div className="node-header">
          FILTER{" "}
          <i
            className=" fa fa-plus"
            style={{ marginLeft: "6rem" }}
            onClick={handleFilter}
          ></i>
        </div>

        {/* <select  value={filter?.id} onChange={handleFilterChange}>
          <option>select</option>
          {filterData &&
            filterData.map((data) => (
              <option value={data.id} id={data.id}>
                {data.name}
              </option>
            ))}
        </select> */}
        <div className="name">{data?.name}</div>

        <Handle type="target" position="left" />
        <Handle type="source" position="right" />
      </div>
      {addNewFilter && (
        <FilterDetailsModal
          handleModalClose={handleFilter}
          Query={workflowFilter}
          modal={addNewFilter}
          type={'workflow'}
        />
      )}
    </>
  );
};

export default CustomNodeFilterData;
